import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Flex } from "@hopper-ui/components";
import { ProgressBar } from "react-aria-components";

const SIZE = 24;
const STROKE_WIDTH = 4;
const GRADIENT_STOP_COLOR_START = "#5f59ce";
const GRADIENT_STOP_COLOR_END = "#857dfe";

interface Props {
    progress: number;
}

export const QuotaUsageCircularProgress = ({ progress }: Props) => {
    const { tShared } = useSharedTranslation();
    const radius = (SIZE - STROKE_WIDTH) / 2;
    const circumference = 2 * Math.PI * radius;
    const center = SIZE / 2;

    const progressStyle = {
        "--progress-percent": progress,
        "--circumference": circumference,
        "--dashoffset": circumference - (progress / 100) * circumference
    } as React.CSSProperties;

    return (
        <ProgressBar
            value={progress}
            maxValue={100}
            aria-label={tShared("quotaUsageProgress")}
        >
            <Flex
                alignItems="center"
                justifyContent="center"
                position="relative"
                UNSAFE_width={`${SIZE}px`}
                UNSAFE_height={`${SIZE}px`}
            >
                <svg
                    width={SIZE}
                    height={SIZE}
                    viewBox={`0 0 ${SIZE} ${SIZE}`}
                    style={{ transform: "rotate(-90deg)" }}
                >
                    <defs>
                        <linearGradient id="wai-circular-progress-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor={GRADIENT_STOP_COLOR_START} />
                            <stop offset="100%" stopColor={GRADIENT_STOP_COLOR_END} />
                        </linearGradient>
                    </defs>
                    {/* Background circle */}
                    <circle
                        cx={center}
                        cy={center}
                        r={radius}
                        fill="none"
                        stroke="var(--hop-neutral-surface-strong)"
                        strokeOpacity={0.1}
                        strokeWidth={STROKE_WIDTH}
                    />
                    {/* Progress arc */}
                    <circle
                        cx={center}
                        cy={center}
                        r={radius}
                        fill="none"
                        stroke="url(#wai-circular-progress-gradient)"
                        strokeWidth={STROKE_WIDTH}
                        strokeDasharray={circumference}
                        strokeDashoffset="var(--dashoffset)"
                        style={progressStyle}
                        strokeLinecap="round"
                    />
                </svg>
            </Flex>
        </ProgressBar>
    );
};
